/**
 * Close Popup Action
 * Uses the existing runTogglePopup with action='hide' and unique event ID targeting
 */

import { runModalToggle } from './runPopupToggle.jsx';

export const runPopupClose = async (data = {}) => {
  try {
    const { eventId, targetEventId, ...otherData } = data;

    // Use targetEventId as selector if provided, otherwise use eventId
    const selector = targetEventId ? `#${targetEventId}` : eventId ? `#${eventId}` : '#arc-modal';

    return await runModalToggle({
      action: 'hide',
      selector,
      ...otherData
    });
  } catch (error) {
    console.error('Close popup error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runPopupClose;
